import React from "react";
import file from "../assets/notification_icon.png";
import no_notifications from "../assets/no_notification_icon.png";
import close from "../assets/cancel.svg";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  useHistory,
  // useLocation
} from "react-router-dom";
import endpoint from "../config/endpoint";
import { apis } from "../config/apis";
import { notifications } from "../actions/auth/Action";

const Notifications = ({ onClose }) => {
  const alerts = useSelector((state) => state?.auth?.alerts?.data);
  const history = useHistory();
  // const location = useLocation()
  const dispatch = useDispatch();
  return (
    <div className="notifications">
      <h3 className="flex-between">
        <span>Notifications</span>
        <img
          src={close}
          width={18}
          className="cursor"
          onClick={onClose}
          alt=""
        />
      </h3>
      {!alerts?.alerts_list?.length ? (
        <ul className="flex-center h100">
          <li>
            <img className="w100" src={no_notifications} alt="notify" />
            <p className="text-center">You have no notifications right now.</p>
          </li>
        </ul>
      ) : (
        <ul>
          {alerts?.alerts_list?.map((ele) => (
            <li
              className={`flex-between notify-hover ${
                ele.Seen === "" ? "unread" : ""
              }`}
              onClick={() => {
                endpoint
                  .get(apis.alerts_seen_status, {
                    params: {
                      email: localStorage.getItem("email"),
                      doc_number: ele.DocNo,
                      doc_type: ele.DocType,
                    },
                  })
                  .then(() => {
                    dispatch(notifications());

                    if (ele.DocType === "BD") {
                      history.push("/payments");
                    }

                    if (ele.DocType === "CN") {
                      history.push("/transactions");
                    }

                    if (ele.DocType === "SO" || ele.DocType === "PI") {
                      history.push("/order-detail/" + parseInt(ele.Eportalordno), {
                        order_number: ele.Eportalordno,
                      });
                    }
                    if (
                      ele.DocType === "SP" ||
                      ele.DocType === "DO" ||
                      ele.DocType === "PSA"
                    ) {
                      history.push(
                        "/shipment-detail/" + ele.DocType === "SP"
                          ? parseInt(ele.DocNo2)
                          : parseInt(ele.DocNo),
                        {
                          do_number:
                            ele.DocType === "SP" ? ele.DocNo2 : ele.DocNo,
                        }
                      );
                    }
                    onClose();
                  });
              }}
            >
              <span className="flex-center w20">
                <img src={file} alt="file" />
              </span>
              <div className="w80">
                <p
                  style={{
                    minWidth: "230px",
                    cursor: "pointer",
                  }}
                >
                  {ele.Notification}
                </p>
                <label>
                  {moment(ele.DocDate, "YYYYMMDD").format("DD/MM/YYYY")}{" "}
                  {moment(ele.DocTime, "hhmmss").format("HH:mm a")}
                </label>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notifications;
